import { z } from 'zod'

// one remembered rename: the CSV's own description (normalized) and what the user changed it to
// during a previous import. stored under UserSettingKey.IMPORT_DESCRIPTION_MAPPING.
export const importDescriptionMappingEntrySchema = z.object({
  // the original description as it came out of the bank, trimmed and case-folded
  from: z.string().min(1).max(300),
  // the replacement, stored verbatim — this is what gets suggested, so its casing matters
  to: z.string().min(1).max(300),
})

// expense and income descriptions are separate vocabularies, so each kind keeps its own list.
// ordered least-recently-used first, like the category dictionary, so the size guard drops the
// stalest renames rather than failing the write.
export const importDescriptionMappingSchema = z.object({
  expense: z.array(importDescriptionMappingEntrySchema).max(500).default([]),
  income: z.array(importDescriptionMappingEntrySchema).max(500).default([]),
})

export type ImportDescriptionMappingEntryDto = z.infer<typeof importDescriptionMappingEntrySchema>
export type ImportDescriptionMappingDto = z.infer<typeof importDescriptionMappingSchema>
